<template>
  <div class="td-root mt-5" :style="brandStyle">
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      :color="message.type === 'error' ? '#dc2626' : '#64748b'">
      <span class="body-1 font-weight-light white--text" v-html="message.text" />
      <template v-slot:action="{ attrs }">
        <v-btn icon color="white" v-bind="attrs" @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Modal Dokumen -->
    <v-dialog v-model="dialog.doc" max-width="900" scrollable>
      <v-card v-if="selectedDoc" class="td-modal">
        <v-card-title class="td-modal-header py-2 px-4">
          <div>
            <div class="td-modal-title">{{ selectedDoc.tenant_doc_name }}</div>
            <div class="td-modal-sub">Diunggah: {{ formatDateTime(selectedDoc.tenant_doc_upload_datetime) }}</div>
          </div>
          <v-spacer />
          <v-btn icon @click="closeDoc"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4 td-modal-body">
          <v-img
            v-if="selectedDoc.tenant_doc_type === 'image'"
            :src="selectedDoc.tenant_doc_url"
            contain
            max-height="480"
            class="mx-auto rounded-lg" />
          <div v-else class="td-doc-fallback">
            <v-icon size="64" class="td-danger-text">mdi-file-pdf-box</v-icon>
            <div class="mt-2 td-value">{{ selectedDoc.tenant_doc_name }}</div>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4 d-flex flex-wrap justify-space-between">
          <div class="td-text-xs td-text-muted">
            Diunggah oleh: {{ selectedDoc.tenant_doc_upload_user_name || '-' }}
          </div>
          <div>
            <v-btn small outlined class="td-btn-outline mr-2 text-capitalize" @click="notify('Buka tab baru dummy.')">Buka di Tab Baru</v-btn>
            <v-btn small outlined class="td-btn-outline text-capitalize" @click="closeDoc">Tutup</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Foto -->
    <v-dialog v-model="dialog.foto" max-width="960">
      <v-card class="td-modal">
        <v-card-title class="td-modal-header py-3 px-6">
          <div>
            <div class="td-modal-title-lg">Foto Unit Submission</div>
            <div class="td-modal-sub">Foto {{ selectedFotoIndex + 1 }} dari {{ currentFotoArray.length }}</div>
          </div>
          <v-spacer />
          <v-btn icon @click="dialog.foto = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4 text-center">
          <v-img :src="selectedFoto" contain max-height="520" class="rounded-lg mx-auto" />
        </v-card-text>
        <v-card-actions class="pa-4 justify-center">
          <v-btn icon :disabled="selectedFotoIndex <= 0" @click="prevFoto"><v-icon>mdi-chevron-left</v-icon></v-btn>
          <v-btn icon :disabled="selectedFotoIndex >= currentFotoArray.length - 1" @click="nextFoto"><v-icon>mdi-chevron-right</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <section class="px-4 pb-4">
      <router-link to="/penghuni-rusunawa" class="td-back d-inline-flex align-center mb-3 text-decoration-none">
        <v-avatar tile size="20" class="td-back-icon">
          <v-img contain :src="require('@/assets/icon/back_arrow.png')" />
        </v-avatar>
        <span class="td-back-label ml-3">Detail Penghuni</span>
      </router-link>

      <div v-if="process.load" class="td-loading">
        <div class="mb-4 title">Mohon Tunggu . . .</div>
        <v-progress-linear :color="set_color" indeterminate height="4" class="td-progress" style="max-width: 320px;" />
      </div>

      <div v-else class="td-layout">
        <!-- Sidebar -->
        <aside class="td-sidebar">
          <div class="td-sidebar-inner">
            <div class="td-profile-card">
              <div class="td-profile-head">
                <v-avatar size="56" :color="set_color_rgb_down" class="td-avatar flex-shrink-0">
                  <span class="td-avatar-text font-weight-medium" :style="{ color: set_color }">{{ initials }}</span>
                </v-avatar>
                <div class="td-profile-head-text min-width-0">
                  <h2 class="td-name mb-0">{{ detail.name }}</h2>
                  <p class="td-category mb-0">{{ detail.category_title }}</p>
                </div>
              </div>

              <div class="td-glance">
                <div class="td-glance-item">
                  <div class="td-glance-value">{{ detail.unitData.number || '-' }}</div>
                  <div class="td-glance-label">Unit</div>
                </div>
                <div class="td-glance-item">
                  <div class="td-glance-value">{{ formatCurrency(monthlyRent) }}</div>
                  <div class="td-glance-label">Sewa / bln</div>
                </div>
                <div class="td-glance-item">
                  <div class="td-glance-value" :class="{ 'td-danger-text': unpaidCount > 0 }">
                    {{ formatCurrency(totalUnpaid) }}
                  </div>
                  <div class="td-glance-label">Tunggakan</div>
                </div>
              </div>

              <div class="td-status-chips">
                <span class="td-status-chip" :class="unpaidCount > 0 ? 'td-status-chip--danger' : 'td-status-chip--brand'">
                  {{ unpaidCount > 0 ? unpaidCount + ' tagihan belum lunas' : 'Tagihan lunas' }}
                </span>
                <span class="td-status-chip td-status-chip--neutral" v-if="openComplaintCount > 0">
                  {{ openComplaintCount }} aduan aktif
                </span>
                <span class="td-status-chip td-status-chip--neutral">
                  Kontrak s/d {{ formatDate(detail.submission_end_date) }}
                </span>
              </div>

              <div class="td-profile-actions">
                <v-btn
                  small
                  elevation="0"
                  class="td-btn-action td-btn-action--primary text-capitalize"
                  @click="notify('Ubah data dummy.')">
                  <v-icon size="14" class="mr-1">mdi-square-edit-outline</v-icon>
                  Ubah
                </v-btn>
                <v-btn
                  small
                  elevation="0"
                  class="td-btn-action td-btn-action--secondary text-capitalize"
                  @click="notify('Pengajuan dummy.')">
                  <v-icon size="14" class="mr-1">mdi-eye-outline</v-icon>
                  Pengajuan
                </v-btn>
              </div>

              <div class="td-stats-grid">
                <div class="td-stat">
                  <div class="td-stat-value">{{ formatCurrency(totalPaid) }}</div>
                  <div class="td-stat-label">Terbayar</div>
                </div>
                <div class="td-stat">
                  <div class="td-stat-value" :class="{ 'td-danger-text': unpaidCount > 0 }">{{ formatCurrency(totalUnpaid) }}</div>
                  <div class="td-stat-label">Belum bayar</div>
                </div>
                <div class="td-stat">
                  <div class="td-stat-value">{{ detail.invoices ? detail.invoices.length : 0 }}</div>
                  <div class="td-stat-label">Invoice</div>
                </div>
              </div>

              <div class="td-info-list">
                <div v-for="item in profileItems" :key="item.label" class="td-info-row">
                  <v-icon size="14" class="td-info-icon mr-2 flex-shrink-0">{{ item.icon }}</v-icon>
                  <div class="flex-grow-1 min-width-0">
                    <p class="td-info-label">{{ item.label }}</p>
                    <p class="td-info-value" :class="{ 'text-truncate': item.truncate }">{{ item.value }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </aside>

        <!-- Main tabs -->
        <main class="td-main">
          <div class="td-main-card">
            <div class="td-tabs-bar">
              <nav class="td-tabs-nav">
                <button
                  v-for="tab in tabs"
                  :key="tab.value"
                  type="button"
                  class="td-tab-btn"
                  :class="{ 'td-tab-btn--active': activeTab === tab.value }"
                  @click="activeTab = tab.value">
                  <v-icon size="16" class="mr-1">{{ tab.icon }}</v-icon>
                  <span>{{ tab.text }}</span>
                </button>
              </nav>
            </div>

            <div class="td-tab-content">
              <!-- UNIT -->
              <div v-show="showSection('unit')" class="td-section-wrap">
                <div class="td-panel">
                  <div class="td-panel-header">
                    <div class="td-panel-icon"><v-icon size="16">mdi-home-outline</v-icon></div>
                    Informasi Unit
                  </div>
                  <div class="td-unit-grid pa-4 pt-0">
                    <div class="td-unit-stat">
                      <div class="td-unit-stat-value">{{ detail.unitData.number || '-' }}</div>
                      <div class="td-unit-stat-label">Nomor Unit</div>
                    </div>
                    <div class="td-unit-stat">
                      <div class="td-unit-stat-value">{{ detail.unitData.tower_name || '-' }}</div>
                      <div class="td-unit-stat-label">Gedung</div>
                    </div>
                    <div class="td-unit-stat">
                      <div class="td-unit-stat-value">Lantai {{ detail.unitData.floor_number || '-' }}</div>
                      <div class="td-unit-stat-label">Lantai</div>
                    </div>
                    <div class="td-unit-stat">
                      <div class="td-unit-stat-value">{{ detail.unitData.type || '-' }}</div>
                      <div class="td-unit-stat-label">Tipe Unit</div>
                    </div>
                    <div class="td-unit-stat">
                      <div class="td-unit-stat-value">{{ detail.unitData.price_description || '-' }}</div>
                      <div class="td-unit-stat-label">Tipe Sewa</div>
                    </div>
                    <div class="td-unit-stat">
                      <div class="td-unit-stat-value">{{ formatCurrency(monthlyRent) }}</div>
                      <div class="td-unit-stat-label">Sewa Bulanan</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- KONTRAK -->
              <div v-show="showSection('kontrak')" class="td-section-wrap">
                <div class="td-panel td-panel--flush">
                  <div class="td-panel-header">
                    <div class="td-panel-icon"><v-icon size="16">mdi-calendar-range</v-icon></div>
                    Informasi Kontrak
                  </div>
                  <div class="pa-2">
                    <div class="td-kontrak-card">
                      <div class="d-flex flex-column flex-sm-row align-sm-center mb-2">
                        <div class="td-kontrak-icon-wrap mr-3 mb-2 mb-sm-0">
                          <v-icon>mdi-calendar-range</v-icon>
                        </div>
                        <div class="flex-grow-1">
                          <div class="td-kontrak-label">Periode Perjanjian Sewa Hunian</div>
                          <div class="td-kontrak-period">
                            {{ formatDate(detail.submission_start_date) }} • {{ formatDate(detail.submission_end_date) }}
                          </div>
                        </div>
                        <span class="td-kontrak-badge">12 bulan</span>
                      </div>
                      <div class="td-kontrak-subcard mb-2">
                        <div class="td-kontrak-sub-label"><v-icon size="12" class="mr-1">mdi-file-document-outline</v-icon> NO Perjanjian</div>
                        <div class="td-kontrak-sub-value">{{ detail.last_perjanjian_number || '-' }}</div>
                      </div>
                      <v-row dense>
                        <v-col cols="12" sm="6">
                          <div class="td-kontrak-subcard">
                            <div class="td-kontrak-sub-label"><v-icon size="12" class="mr-1">mdi-calendar</v-icon> Mulai Perjanjian</div>
                            <div class="td-kontrak-sub-value">{{ formatDate(detail.submission_start_date) }}</div>
                          </div>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <div class="td-kontrak-subcard">
                            <div class="td-kontrak-sub-label"><v-icon size="12" class="mr-1">mdi-calendar</v-icon> Selesai Perjanjian</div>
                            <div class="td-kontrak-sub-value">{{ formatDate(detail.submission_end_date) }}</div>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </div>
              </div>

              <!-- FOTO -->
              <div v-show="showSection('foto')" class="td-section-wrap">
                <div class="td-panel">
                  <div class="td-panel-header">
                    <div class="td-panel-icon"><v-icon size="16">mdi-image-outline</v-icon></div>
                    Foto Penghuni
                  </div>
                  <div class="pa-4 pt-0">
                    <v-row v-if="detail.fotos && detail.fotos.length">
                      <v-col v-for="(url, index) in detail.fotos" :key="index" cols="6" lg="3">
                        <div class="td-foto-card">
                          <div class="td-foto-img-wrap" @click="openFoto(url, index, detail.fotos)">
                            <v-img :src="url" height="160" cover />
                          </div>
                          <div class="td-foto-footer">
                            <span class="td-text-xs td-text-muted">Foto {{ index + 1 }}</span>
                            <v-btn icon x-small outlined class="td-btn-icon" @click="openFoto(url, index, detail.fotos)">
                              <v-icon size="16">mdi-eye-outline</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <div v-else class="td-empty py-8">Tidak ada foto tersedia</div>
                  </div>
                </div>
              </div>

              <!-- COMPLAINTS -->
              <div v-show="showSection('complaints')" class="td-section-wrap">
                <div class="td-panel">
                  <div class="td-panel-header">
                    <div class="td-panel-icon"><v-icon size="16">mdi-message-alert-outline</v-icon></div>
                    Riwayat Aduan
                  </div>
                  <div class="pa-4 pt-0">
                    <template v-if="detail.complaints && detail.complaints.length">
                      <div
                        v-for="(item, index) in detail.complaints"
                        :key="item.id"
                        class="td-complaint-item"
                        :class="{ 'td-complaint-item--last': index === detail.complaints.length - 1 }">
                        <div class="d-flex">
                          <div class="td-panel-icon mr-3 flex-shrink-0"><v-icon size="16">mdi-message-alert-outline</v-icon></div>
                          <div class="flex-grow-1">
                            <div class="d-flex flex-wrap align-center mb-2">
                              <h4 class="td-complaint-title mr-2">{{ item.number }}</h4>
                              <span class="td-badge mr-1" :class="statusBadgeClass(item.last_status)">{{ item.last_status }}</span>
                              <span class="td-badge" :class="priorityBadgeClass(item.priority)">{{ item.priority }}</span>
                            </div>
                            <div class="td-text-xs td-text-muted mb-2">Kategori: {{ item.category }}</div>
                            <p class="td-complaint-content mb-2">{{ item.content }}</p>
                            <div class="td-text-xs td-text-muted">
                              Dilaporkan: {{ formatDate(item.create_datetime) }}
                              <span v-if="item.assigned_to_user_name"> • Petugas: {{ item.assigned_to_user_name }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <div v-else class="td-empty py-8">Tidak ada data aduan</div>
                  </div>
                </div>
              </div>

              <!-- DOCUMENTS -->
              <div v-show="showSection('documents')" class="td-section-wrap">
                <div class="td-panel">
                  <div class="td-panel-header">
                    <div class="td-panel-icon"><v-icon size="16">mdi-file-document-outline</v-icon></div>
                    Dokumen
                  </div>
                  <div class="pa-4 pt-0">
                    <v-row v-if="detail.documents && detail.documents.length">
                      <v-col v-for="doc in detail.documents" :key="doc.tenant_doc_id" cols="12" sm="6">
                        <div class="td-doc-card">
                          <div class="td-text-xs td-text-muted mb-1">{{ formatDateTime(doc.tenant_doc_upload_datetime) }}</div>
                          <div class="td-doc-title">{{ doc.tenant_doc_name }}</div>
                          <div class="td-text-xs td-text-muted mb-2">Diunggah oleh: {{ doc.tenant_doc_upload_user_name || '-' }}</div>
                          <div v-if="doc.tenant_doc_validated_bool === '1'" class="td-validated td-validated--ok mb-2">
                            <v-icon size="12" class="mr-1">mdi-check-circle</v-icon>
                            Tervalidasi: {{ formatDateTime(doc.tenant_doc_validated_datetime) }} oleh {{ doc.tenant_doc_validated_user_name || '-' }}
                          </div>
                          <div v-else-if="doc.tenant_doc_validated_bool === '0'" class="td-validated td-validated--no mb-2">
                            <v-icon size="12" class="mr-1">mdi-close-circle</v-icon>
                            Belum tervalidasi
                          </div>
                          <div v-if="doc.tenant_doc_type === 'image'" class="td-doc-preview td-doc-preview--image mb-3">
                            <v-img :src="doc.tenant_doc_url" contain height="160" />
                          </div>
                          <div v-else-if="doc.tenant_doc_type === 'pdf'" class="td-doc-preview td-doc-preview--pdf mb-3">
                            <div class="td-doc-emoji">📄</div>
                            <span class="td-text-xs td-text-muted font-weight-medium">PDF Document</span>
                          </div>
                          <div class="d-flex align-center justify-space-between mt-3">
                            <v-btn small outlined class="td-btn-outline text-capitalize" @click="viewDocument(doc)">
                              <v-icon size="16" class="mr-1">mdi-eye-outline</v-icon> Lihat
                            </v-btn>
                            <v-btn small outlined class="td-btn-outline text-capitalize" @click="notify('Unduh dokumen dummy.')">
                              <v-icon size="16" class="mr-1">mdi-download</v-icon> Unduh
                            </v-btn>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <div v-else class="td-text-xs td-text-muted">Tidak ada dokumen.</div>
                  </div>
                </div>
              </div>

              <!-- SURAT -->
              <div v-show="showSection('surat-peringatan')" class="td-section-wrap">
                <div class="td-panel">
                  <div class="td-panel-header">
                    <div class="td-panel-icon"><v-icon size="16">mdi-file-alert-outline</v-icon></div>
                    Riwayat Surat
                  </div>
                  <div class="pa-4 pt-0">
                    <template v-if="detail.suratPeringatan && detail.suratPeringatan.length">
                      <div
                        v-for="(item, index) in detail.suratPeringatan"
                        :key="item.id"
                        class="td-complaint-item"
                        :class="{ 'td-complaint-item--last': index === detail.suratPeringatan.length - 1 }">
                        <div class="d-flex">
                          <div class="td-panel-icon mr-3"><v-icon size="16">mdi-file-alert-outline</v-icon></div>
                          <div class="flex-grow-1">
                            <div class="d-flex flex-wrap align-center mb-2">
                              <h4 class="td-complaint-title mr-2">{{ item.title }}</h4>
                              <span class="td-badge td-badge--neutral">{{ item.doc_category_title }}</span>
                            </div>
                            <div class="td-text-xs td-text-muted mb-1">Nomor: {{ item.number }}</div>
                            <div class="td-text-xs td-text-muted mb-1">Tanggal: {{ formatDateTime(item.date) }}</div>
                            <div class="td-text-xs td-text-muted mb-2">Unit: {{ item.unit_number }}</div>
                            <v-btn small outlined class="td-btn-outline text-capitalize mt-2" @click="notify('Lihat dokumen surat dummy.')">
                              <v-icon size="16" class="mr-1">mdi-eye-outline</v-icon> Lihat Dokumen
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </template>
                    <div v-else class="td-empty py-8">Tidak ada data surat peringatan</div>
                  </div>
                </div>
              </div>

              <!-- FINANCE -->
              <div v-show="showSection('finance')" class="td-section-wrap">
                <div class="td-panel mb-5">
                  <div class="td-panel-header">
                    <div class="td-panel-icon"><v-icon size="16">mdi-cash-multiple</v-icon></div>
                    Ringkasan Invoice Sewa Unit
                  </div>
                  <div class="pa-4 pt-0">
                    <div class="td-summary td-summary--neutral td-row-gap">
                      <div>
                        <p class="td-summary-label">Total Terbayar</p>
                        <p class="td-summary-value">{{ formatCurrency(totalPaid) }}</p>
                      </div>
                    </div>
                    <div class="td-summary td-summary--neutral">
                      <div>
                        <p class="td-summary-label">Total Belum Bayar</p>
                        <p class="td-summary-value" :class="{ 'td-danger-text': unpaidCount > 0 }">{{ formatCurrency(totalUnpaid) }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="td-panel mb-5">
                  <div class="td-panel-header">
                    <div class="td-panel-icon"><v-icon size="16">mdi-credit-card-outline</v-icon></div>
                    Informasi Virtual Account
                  </div>
                  <div class="td-va-grid pa-4 pt-0">
                    <div class="td-va-card">
                      <p class="td-va-label">VA Sewa</p>
                      <p class="td-va-value">{{ detail.va_sewa || '-' }}</p>
                    </div>
                    <div class="td-va-card">
                      <p class="td-va-label">VA Air</p>
                      <p class="td-va-value">{{ detail.va_air || '-' }}</p>
                    </div>
                  </div>
                </div>

                <div class="td-panel">
                  <div class="td-panel-header">
                    <div class="td-panel-icon"><v-icon size="16">mdi-receipt-text-outline</v-icon></div>
                    Daftar Invoice
                  </div>
                  <div class="pa-4 pt-0">
                    <template v-if="detail.invoices && detail.invoices.length">
                      <div
                        v-for="(inv, index) in detail.invoices"
                        :key="inv.id"
                        class="td-invoice-card td-row-gap">
                        <div class="d-flex flex-column flex-sm-row justify-space-between">
                          <div class="d-flex flex-grow-1 mb-3 mb-sm-0">
                            <div class="td-invoice-dot mr-3 mt-1" :class="invoiceDotClass(inv)" />
                            <div class="flex-grow-1 min-width-0">
                              <div class="d-flex flex-wrap align-center mb-2">
                                <p class="td-invoice-title mr-2">Invoice Sewa Unit Ke {{ index + 1 }} - #{{ inv.number }}</p>
                                <span class="td-badge" :class="statusBadgeClass(inv.status)">{{ inv.status }}</span>
                              </div>
                              <div class="d-flex flex-wrap">
                                <span v-if="inv.datetime" class="td-date-badge td-date-badge--neutral mr-2 mb-1">
                                  Tanggal: {{ formatDateTime(inv.datetime) }}
                                </span>
                                <span v-if="inv.due_datetime" class="td-date-badge mr-2 mb-1" :class="dueBadgeClass(inv)">
                                  Jatuh Tempo: {{ formatDateTime(inv.due_datetime) }}
                                  <span v-if="isOverdue(inv)"> (Terlambat)</span>
                                </span>
                              </div>
                              <p v-if="inv.paid_datetime" class="td-text-xs td-text-muted mt-1 mb-0">
                                Dibayar: {{ formatDateTime(inv.paid_datetime) }}
                              </p>
                            </div>
                          </div>
                          <div class="text-sm-right flex-shrink-0">
                            <p class="td-text-xs td-text-muted mb-0">Nominal</p>
                            <p class="td-invoice-nominal">{{ formatCurrency(inv.nominal) }}</p>
                          </div>
                        </div>
                      </div>
                    </template>
                    <div v-else class="td-empty py-8">Tidak ada data invoice</div>
                  </div>
                </div>
              </div>

              <!-- INVOICE AIR -->
              <div v-show="showSection('invoice-air')" class="td-section-wrap">
                <div class="td-panel">
                  <div class="td-panel-header">
                    <div class="td-panel-icon"><v-icon size="16">mdi-water-outline</v-icon></div>
                    Invoice Sewa Air
                  </div>
                  <div class="pa-4 pt-0">
                    <template v-if="detail.invoiceAir && detail.invoiceAir.length">
                      <div
                        v-for="inv in detail.invoiceAir"
                        :key="inv.id"
                        class="td-invoice-card td-invoice-air td-row-gap">
                        <div class="td-invoice-air-header mb-4 pb-3">
                          <div class="d-flex align-center justify-space-between mb-2">
                            <h3 class="td-invoice-air-number">{{ inv.number }}</h3>
                            <span class="td-badge" :class="statusBadgeClass(inv.status)">{{ inv.status }}</span>
                          </div>
                          <div class="td-text-xs td-text-muted">
                            <div v-if="inv.datetime">Tanggal: {{ formatDate(inv.datetime) }}</div>
                            <div v-if="inv.due_datetime" :class="{ 'td-danger-text': isOverdue(inv) }">
                              Jatuh Tempo: {{ formatDate(inv.due_datetime) }}
                            </div>
                            <div v-if="inv.paid_datetime" class="td-text-xs td-text-muted">Dibayar: {{ formatDate(inv.paid_datetime) }}</div>
                          </div>
                        </div>
                        <div class="td-meter-grid mb-4 pb-3">
                          <div>
                            <p class="td-text-xs td-text-muted mb-1">Nilai Sebelumnya</p>
                            <p class="td-value mb-1">{{ formatMeter(inv.flow_meter_value_before) }} M³</p>
                          </div>
                          <div>
                            <p class="td-text-xs td-text-muted mb-1">Nilai Sekarang</p>
                            <p class="td-value mb-1">{{ formatMeter(inv.flow_meter_value) }} M³</p>
                          </div>
                          <div>
                            <p class="td-text-xs td-text-muted mb-1">Pemakaian</p>
                            <p class="td-value mb-1">{{ formatMeter(waterUsage(inv)) }} M³</p>
                          </div>
                        </div>
                        <div v-if="inv.invoice_detail && inv.invoice_detail.length" class="td-receipt mb-4">
                          <div class="td-receipt-title">RINCIAN BIAYA</div>
                          <div v-for="(d, i) in inv.invoice_detail" :key="i" class="td-receipt-row">
                            <div>
                              <p class="td-receipt-name mb-0">{{ d.name }}</p>
                              <p class="td-text-xs td-text-muted mb-0">{{ formatCurrency(d.nominal) }}</p>
                            </div>
                            <span class="td-value">{{ formatCurrency(d.subtotal || d.nominal) }}</span>
                          </div>
                        </div>
                        <div class="d-flex justify-space-between align-center pt-3 td-invoice-air-total">
                          <p class="td-value mb-0">Total Tagihan</p>
                          <p class="td-invoice-nominal mb-0">{{ formatCurrency(inv.nominal) }}</p>
                        </div>
                        <v-btn small outlined block class="td-btn-outline text-capitalize mt-3" @click="notify('Detail invoice air dummy.')">
                          <v-icon size="16" class="mr-1">mdi-eye-outline</v-icon> Lihat Detail
                        </v-btn>
                      </div>
                    </template>
                    <div v-else class="td-empty py-8">Tidak ada data Invoice Sewa Air</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/id'

const buildDummyDetail = (id) => {
  const base = {
    1: { name: 'Budi Santoso', category_title: 'MBR', gender: 'Laki-laki', email: 'budi.santoso@email.com', mobilephone: '081234567890', nik: '3374010101010001', kk: '3374010101010001', job: 'Karyawan Swasta', salary: 4500000, address: 'Jl. Merdeka No. 10', village_name: 'Pekunden', subdistrict_name: 'Semarang Tengah', city_name: 'Semarang', province_name: 'Jawa Tengah', unit_number: '1A-0401', last_perjanjian_number: 'PKS/001/2024', va_sewa: '880012345678901', va_air: '880098765432109', unit_water_meter: 'WM-1A-0401', submission_start_date: '2024-01-15', submission_end_date: '2026-01-14' },
    2: { name: 'Siti Aminah', category_title: 'Non-MBR', gender: 'Perempuan', email: 'siti.aminah@email.com', mobilephone: '081298765432', nik: '3374020202020002', kk: '3374020202020002', job: 'Pedagang', salary: 3800000, address: 'Jl. Diponegoro No. 25', village_name: 'Pekunden', subdistrict_name: 'Semarang Tengah', city_name: 'Semarang', province_name: 'Jawa Tengah', unit_number: '1B-0512', last_perjanjian_number: 'PKS/002/2024', va_sewa: '880012345678902', va_air: '880098765432110', unit_water_meter: 'WM-1B-0512', submission_start_date: '2024-02-01', submission_end_date: '2026-01-31' },
    3: { name: 'Ahmad Wijaya', category_title: 'MBR', gender: 'Laki-laki', email: 'ahmad.wijaya@email.com', mobilephone: '081345678901', nik: '3374030303030003', kk: '3374030303030003', job: 'Buruh', salary: 3200000, address: 'Jl. Gajah Mada No. 5', village_name: 'Pekunden', subdistrict_name: 'Semarang Tengah', city_name: 'Semarang', province_name: 'Jawa Tengah', unit_number: '2A-0305', last_perjanjian_number: 'PKS/003/2024', va_sewa: '880012345678903', va_air: '880098765432111', unit_water_meter: null, submission_start_date: '2024-03-10', submission_end_date: '2026-03-09' }
  }
  const row = base[id] || base[1]

  return {
    id,
    ...row,
    unitData: {
      number: row.unit_number,
      tower_name: row.unit_number.split('-')[0],
      floor_number: row.unit_number.split('-')[1] ? row.unit_number.split('-')[1].substring(0, 2) : '-',
      type: '2BR + 1 Bath',
      price_description: 'Standar'
    },
    fotos: [
      'https://picsum.photos/seed/tenant' + id + 'a/400/400',
      'https://picsum.photos/seed/tenant' + id + 'b/400/400',
      'https://picsum.photos/seed/tenant' + id + 'c/400/400',
      'https://picsum.photos/seed/tenant' + id + 'd/400/400'
    ],
    complaints: [
      { id: 1, number: 'TKT-2025-001', last_status: 'selesai penugasan', priority: 'sedang', category: 'Pemeliharaan', content: 'Keran air di dapur bocor.', create_datetime: '2025-03-10 09:30:00', assigned_to_user_name: 'Teknisi A' },
      { id: 2, number: 'TKT-2025-002', last_status: 'proses', priority: 'tinggi', category: 'Keluhan', content: 'Lampu koridor lantai mati.', create_datetime: '2025-05-02 14:15:00', assigned_to_user_name: 'Teknisi B' }
    ],
    documents: [
      { tenant_doc_id: 1, tenant_doc_name: 'KTP Penghuni', tenant_doc_type: 'image', tenant_doc_url: 'https://picsum.photos/seed/ktp' + id + '/600/400', tenant_doc_upload_datetime: '2024-01-10 10:00:00', tenant_doc_upload_user_name: 'Admin Rusunawa', tenant_doc_validated_bool: '1', tenant_doc_validated_datetime: '2024-01-11 09:00:00', tenant_doc_validated_user_name: 'Validator' },
      { tenant_doc_id: 2, tenant_doc_name: 'Perjanjian Sewa', tenant_doc_type: 'pdf', tenant_doc_url: '#', tenant_doc_upload_datetime: '2024-01-15 11:00:00', tenant_doc_upload_user_name: 'Admin Rusunawa', tenant_doc_validated_bool: '0' }
    ],
    suratPeringatan: [
      { id: 1, title: 'Surat Peringatan I', number: 'SP/001/2025', doc_category_title: 'Surat Peringatan', date: '2025-02-01 08:00:00', unit_number: row.unit_number, input_datetime: '2025-02-01 08:00:00', input_user_name: 'Admin Finance', url: '#' }
    ],
    invoices: [
      { id: 1, number: 'INV-SW-2025-001', status: 'Lunas', nominal: 1500000, datetime: '2025-01-01 00:00:00', due_datetime: '2025-01-15 23:59:59', paid_datetime: '2025-01-12 10:30:00' },
      { id: 2, number: 'INV-SW-2025-002', status: 'Lunas', nominal: 1500000, datetime: '2025-02-01 00:00:00', due_datetime: '2025-02-15 23:59:59', paid_datetime: '2025-02-14 09:00:00' },
      { id: 3, number: 'INV-SW-2025-003', status: 'Belum Lunas', nominal: 1500000, datetime: '2025-03-01 00:00:00', due_datetime: '2025-03-15 23:59:59', paid_datetime: '' }
    ],
    invoiceAir: [
      {
        id: 1,
        number: 'INV-AIR-2025-001',
        status: 'Lunas',
        nominal: 85000,
        datetime: '2025-01-01 00:00:00',
        due_datetime: '2025-01-20 23:59:59',
        paid_datetime: '2025-01-18 11:00:00',
        flow_meter_value_before: 120.5,
        flow_meter_value: 125.0,
        invoice_detail: [
          { name: 'Biaya Air per M3', nominal: 10000, subtotal: 45000 },
          { name: 'Biaya Administrasi', nominal: 40000, subtotal: 40000 }
        ]
      }
    ],
    tenant_device: id % 2 === 0
      ? [{ device_value: 'Samsung Galaxy A54 - Android 14', last_login_datetime: '2025-06-01 07:45:00' }]
      : []
  }
}

export default {
  data () {
    return {
      activeTab: 'all',
      detail: {},
      selectedDoc: null,
      selectedFoto: '',
      selectedFotoIndex: 0,
      currentFotoArray: [],
      dialog: { snackbar: false, foto: false, doc: false },
      message: { text: '', type: 'success' },
      process: { load: true },
      tabs: [
        { value: 'all', text: 'Semua', icon: 'mdi-information-outline' },
        { value: 'unit', text: 'Unit', icon: 'mdi-home-outline' },
        { value: 'kontrak', text: 'Kontrak', icon: 'mdi-calendar-range' },
        { value: 'foto', text: 'Foto Penghuni', icon: 'mdi-image-outline' },
        { value: 'complaints', text: 'Riwayat Aduan', icon: 'mdi-message-alert-outline' },
        { value: 'documents', text: 'Dokumen', icon: 'mdi-file-document-outline' },
        { value: 'finance', text: 'Invoice Sewa Unit', icon: 'mdi-cash-multiple' },
        { value: 'invoice-air', text: 'Invoice Sewa Air', icon: 'mdi-water-outline' },
        { value: 'surat-peringatan', text: 'Riwayat Surat', icon: 'mdi-file-alert-outline' }
      ]
    }
  },
  computed: {
    set_color () {
      return this.$store.state.color
    },
    set_color_rgb_down () {
      const [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
      return `rgba(${r}, ${g}, ${b}, 0.12)`
    },
    brandStyle () {
      return {
        '--td-brand': this.set_color,
        '--td-brand-soft': this.set_color_rgb_down
      }
    },
    initials () {
      if (!this.detail.name) return 'P'
      return this.detail.name.split(' ').map(w => w.charAt(0)).join('').toUpperCase().slice(0, 2)
    },
    fullAddress () {
      const d = this.detail
      return [d.address, d.village_name, d.subdistrict_name, d.city_name, d.province_name].filter(Boolean).join(', ')
    },
    profileItems () {
      return [
        { icon: 'mdi-account-outline', label: 'Jenis Kelamin', value: this.detail.gender || '-' },
        { icon: 'mdi-email-outline', label: 'Email', value: this.detail.email || '-', truncate: true },
        { icon: 'mdi-phone-outline', label: 'Phone', value: this.detail.mobilephone || '-' },
        { icon: 'mdi-map-marker-outline', label: 'Alamat', value: this.fullAddress || '-' },
        { icon: 'mdi-card-account-details-outline', label: 'KTP', value: this.detail.nik || '-' },
        { icon: 'mdi-file-document-outline', label: 'Kartu Keluarga', value: this.detail.kk || '-' },
        { icon: 'mdi-currency-usd', label: 'Pekerjaan - Gaji', value: `${this.detail.job || '-'} - ${this.formatCurrency(this.detail.salary)}` }
      ]
    },
    paidCount () {
      return (this.detail.invoices || []).filter(i => this.isPaid(i.status)).length
    },
    unpaidCount () {
      return (this.detail.invoices || []).filter(i => !this.isPaid(i.status)).length
    },
    totalPaid () {
      return (this.detail.invoices || []).filter(i => this.isPaid(i.status)).reduce((s, i) => s + Number(i.nominal || 0), 0)
    },
    totalUnpaid () {
      return (this.detail.invoices || []).filter(i => !this.isPaid(i.status)).reduce((s, i) => s + Number(i.nominal || 0), 0)
    },
    monthlyRent () {
      const inv = this.detail.invoices && this.detail.invoices[0]
      return inv ? inv.nominal : 0
    },
    openComplaintCount () {
      return (this.detail.complaints || []).filter(c => {
        const s = String(c.last_status || '').toLowerCase()
        return s !== 'selesai penugasan'
      }).length
    }
  },
  mounted () {
    this.fetchDetail()
  },
  methods: {
    showSection (name) {
      return this.activeTab === 'all' || this.activeTab === name
    },
    fetchDetail () {
      this.process.load = true
      const id = Number(this.$route.params.id) || 1
      setTimeout(() => {
        this.detail = buildDummyDetail(id)
        this.process.load = false
      }, 350)
    },
    notify (text, type = 'success') {
      this.message.text = text
      this.message.type = type
      this.dialog.snackbar = true
    },
    openFoto (url, index, arr) {
      this.selectedFoto = url
      this.selectedFotoIndex = index
      this.currentFotoArray = arr
      this.dialog.foto = true
    },
    prevFoto () {
      if (this.selectedFotoIndex <= 0) return
      this.selectedFotoIndex -= 1
      this.selectedFoto = this.currentFotoArray[this.selectedFotoIndex]
    },
    nextFoto () {
      if (this.selectedFotoIndex >= this.currentFotoArray.length - 1) return
      this.selectedFotoIndex += 1
      this.selectedFoto = this.currentFotoArray[this.selectedFotoIndex]
    },
    viewDocument (doc) {
      this.selectedDoc = doc
      this.dialog.doc = true
    },
    closeDoc () {
      this.dialog.doc = false
      this.selectedDoc = null
    },
    formatCurrency (amount) {
      if (!amount && amount !== 0) return '-'
      return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(amount)
    },
    formatDate (value) {
      if (!value) return '-'
      return moment(value).locale('id').format('DD MMM YYYY')
    },
    formatDateTime (value) {
      if (!value) return '-'
      return moment(value).locale('id').format('DD MMM YYYY HH:mm')
    },
    formatMeter (value) {
      if (value === undefined || value === null || value === '') return '-'
      return new Intl.NumberFormat('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value))
    },
    waterUsage (inv) {
      return (inv.flow_meter_value || 0) - (inv.flow_meter_value_before || 0)
    },
    isPaid (status) {
      const s = String(status || '').trim().toLowerCase()
      return s === 'lunas' || s === 'paid'
    },
    isOverdue (inv) {
      return inv.due_datetime && !this.isPaid(inv.status) && moment(inv.due_datetime).isBefore(moment())
    },
    statusBadgeClass (status) {
      const s = String(status || '').trim().toLowerCase()
      if (s === 'belum lunas' || s === 'unpaid') return 'td-badge--danger'
      return 'td-badge--neutral'
    },
    priorityBadgeClass (priority) {
      const p = String(priority || '').trim().toLowerCase()
      if (p === 'tinggi' || p === 'kritis') return 'td-badge--danger'
      return 'td-badge--neutral'
    },
    invoiceDotClass (inv) {
      if (this.isOverdue(inv)) return 'td-invoice-dot--danger'
      return 'td-invoice-dot--neutral'
    },
    dueBadgeClass (inv) {
      if (this.isOverdue(inv)) return 'td-date-badge--danger'
      return 'td-date-badge--neutral'
    }
  }
}
</script>

<style scoped>
/* ── Meta internal admin design tokens ── */
.td-root {
  --td-radius: 6px;
  --td-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  --td-label-size: 11px;
  --td-label-color: #64748b;
  --td-label-weight: 400;
  --td-value-size: 14px;
  --td-value-color: #1e293b;
  --td-value-weight: 500;
  --td-row-gap: 18px;
  --td-border: #e2e8f0;
  --td-bg: #ffffff;
  --td-bg-subtle: #f8fafc;
  --td-brand: #334155;
  --td-brand-soft: rgba(51, 65, 85, 0.12);
  --td-danger: #dc2626;
  --td-danger-bg: #fef2f2;
  --td-danger-border: #fecaca;
  color: var(--td-value-color);
}

.td-danger-text {
  color: var(--td-danger) !important;
}

.td-label,
.td-info-label,
.td-glance-label,
.td-stat-label,
.td-unit-stat-label,
.td-kontrak-label,
.td-kontrak-sub-label,
.td-summary-label,
.td-va-label,
.td-text-xs,
.td-text-muted,
.td-modal-sub,
.td-receipt-title,
.td-empty {
  font-size: var(--td-label-size);
  font-weight: var(--td-label-weight);
  color: var(--td-label-color);
}

.td-value,
.td-info-value,
.td-glance-value,
.td-stat-value,
.td-unit-stat-value,
.td-kontrak-period,
.td-kontrak-sub-value,
.td-complaint-title,
.td-complaint-content,
.td-doc-title,
.td-summary-value,
.td-va-value,
.td-invoice-title,
.td-invoice-nominal,
.td-invoice-air-number,
.td-receipt-name,
.td-name,
.td-modal-title,
.td-modal-title-lg,
.td-back-label {
  font-size: var(--td-value-size);
  font-weight: var(--td-value-weight);
  color: var(--td-value-color);
}

.td-row-gap {
  margin-bottom: var(--td-row-gap);
}

.td-row-gap:last-child {
  margin-bottom: 0;
}

/* ── Vuetify overrides (radius, no animation, no hover noise) ── */
.td-root >>> .v-avatar,
.td-root >>> .v-btn,
.td-root >>> .v-card,
.td-root >>> .v-dialog .v-card,
.td-root >>> .v-img,
.td-root >>> .v-progress-linear,
.td-root >>> .v-snack__wrapper {
  border-radius: 6px !important;
}

.td-root >>> .v-btn,
.td-root >>> .v-btn::before,
.td-root >>> .v-btn:hover::before,
.td-root >>> .v-btn:focus::before,
.td-root >>> .v-btn--active::before {
  transition: none !important;
  animation: none !important;
  opacity: 0 !important;
}

.td-root >>> .v-btn:hover,
.td-root >>> .v-btn:focus,
.td-root >>> .v-btn--active {
  box-shadow: var(--td-shadow) !important;
}

.td-progress >>> .v-progress-linear__determinate,
.td-progress >>> .v-progress-linear__indeterminate {
  border-radius: 6px !important;
}

.td-info-icon {
  color: var(--td-brand) !important;
  opacity: 0.75;
}

/* ── Layout ── */
.td-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--td-row-gap);
  align-items: start;
}

@media (min-width: 1264px) {
  .td-layout {
    grid-template-columns: 1fr 2fr;
  }
}

.td-sidebar-inner {
  position: sticky;
  top: 16px;
}

.td-loading {
  min-height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.td-back-icon {
  opacity: 0.5;
}

/* ── Cards (single shadow, 6px radius) ── */
.td-profile-card,
.td-main-card,
.td-panel,
.td-modal,
.td-glance-item,
.td-stat,
.td-unit-stat,
.td-kontrak-card,
.td-kontrak-subcard,
.td-foto-card,
.td-doc-card,
.td-summary,
.td-va-card,
.td-invoice-card,
.td-receipt,
.td-device-row,
.td-device-empty {
  background: var(--td-bg);
  border: 1px solid var(--td-border);
  border-radius: 6px;
  box-shadow: var(--td-shadow);
}

.td-profile-card {
  padding: 16px;
  /* border-top: 3px solid var(--td-brand); */
}

/* ── Profile ── */
.td-profile-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: var(--td-row-gap);
}

.td-profile-head-text {
  flex: 1;
}

.td-avatar-text {
  font-size: var(--td-value-size);
  font-weight: var(--td-value-weight);
  color: var(--td-value-color);
}

.td-category {
  font-size: var(--td-label-size);
  font-weight: var(--td-label-weight);
  color: var(--td-label-color);
}

/* ── Glance ── */
.td-glance {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: var(--td-row-gap);
}

.td-glance-item {
  padding: 10px 8px;
  text-align: center;
  background: var(--td-bg-subtle);
}

.td-glance-value {
  line-height: 1.35;
  word-break: break-word;
}

.td-glance-label {
  margin-top: 4px;
}

/* ── Status chips (danger only when bahaya) ── */
.td-status-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: var(--td-row-gap);
}

.td-status-chip {
  display: inline-block;
  font-size: var(--td-label-size);
  font-weight: var(--td-label-weight);
  padding: 3px 8px;
  border-radius: 6px;
  line-height: 1.35;
  border: 1px solid var(--td-border);
}

.td-status-chip--neutral {
  background: var(--td-bg-subtle);
  color: var(--td-label-color);
}

.td-status-chip--brand {
  background: var(--td-brand-soft);
  color: var(--td-brand);
  border-color: transparent;
}

.td-status-chip--danger {
  background: var(--td-danger-bg);
  color: var(--td-danger);
  border-color: var(--td-danger-border);
}

/* ── Actions ── */
.td-profile-actions {
  display: flex;
  gap: 8px;
  margin-bottom: var(--td-row-gap);
}

.td-btn-action,
.td-btn-outline,
.td-btn-icon {
  background-color: var(--td-bg-subtle) !important;
  color: var(--td-value-color) !important;
  border: 1px solid var(--td-border) !important;
  box-shadow: var(--td-shadow) !important;
  border-radius: 6px !important;
  letter-spacing: 0 !important;
  font-size: 12px !important;
  font-weight: var(--td-value-weight) !important;
  text-transform: none !important;
  height: 30px !important;
}

.td-btn-outline--brand {
  background-color: var(--td-brand-soft) !important;
  color: var(--td-brand) !important;
  border-color: transparent !important;
}

.td-btn-action {
  flex: 1;
}

.td-btn-action--primary {
  background-color: var(--td-brand) !important;
  color: #ffffff !important;
  border-color: var(--td-brand) !important;
}

.td-btn-action--secondary {
  background-color: var(--td-brand-soft) !important;
  color: var(--td-brand) !important;
  border-color: transparent !important;
}

.td-btn-icon {
  width: 28px !important;
  height: 28px !important;
  min-width: 28px !important;
}

/* ── Stats ── */
.td-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: var(--td-row-gap);
}

.td-stat {
  padding: 10px 8px;
  text-align: center;
  background: var(--td-bg-subtle);
}

.td-stat-value {
  line-height: 1.35;
  word-break: break-word;
}

.td-stat-label {
  margin-top: 4px;
}

/* ── Info list (18px row gap) ── */
.td-info-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: var(--td-row-gap);
}

.td-info-row:last-child {
  margin-bottom: 0;
}

.td-info-label {
  margin-bottom: 2px;
  line-height: 1.35;
}

.td-info-value {
  margin-bottom: 0;
  line-height: 1.4;
}

.td-info-list {
  padding-top: var(--td-row-gap);
  border-top: 1px solid var(--td-border);
}

/* ── Tabs ── */
.td-main-card {
  overflow: hidden;
}

.td-tabs-bar {
  border-bottom: 1px solid var(--td-border);
  background: var(--td-bg);
}

.td-tabs-nav {
  display: flex;
  gap: 0;
  padding: 0 12px;
  overflow-x: auto;
}

.td-tab-btn {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  border: none;
  background: transparent;
  border-bottom: 2px solid transparent;
  padding: 12px 10px;
  font-size: var(--td-label-size);
  font-weight: var(--td-label-weight);
  color: var(--td-label-color);
  cursor: pointer;
  white-space: nowrap;
  letter-spacing: 0;
  text-transform: none;
  transition: none;
}

.td-tab-btn--active {
  border-bottom-color: var(--td-brand);
  color: var(--td-brand);
  font-weight: var(--td-value-weight);
}

.td-tab-btn .v-icon {
  color: var(--td-label-color) !important;
}

.td-tab-btn--active .v-icon {
  color: var(--td-brand) !important;
}

.td-tab-content {
  padding: 16px;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
}

.td-section-wrap {
  margin-bottom: var(--td-row-gap);
}

.td-section-wrap:last-child {
  margin-bottom: 0;
}

/* ── Panels ── */
.td-panel {
  overflow: hidden;
}

.td-panel-header {
  display: flex;
  align-items: center;
  font-size: var(--td-value-size);
  font-weight: var(--td-value-weight);
  color: var(--td-value-color);
  border-bottom: 1px solid var(--td-border);
  /* border-left: 3px solid var(--td-brand); */
  padding: 12px 16px;
  background: var(--td-brand-soft);
}

.td-panel-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  margin-right: 8px;
  flex-shrink: 0;
  background: var(--td-bg);
}

.td-panel-icon .v-icon {
  color: var(--td-brand) !important;
  font-size: 16px !important;
  opacity: 0.9;
}

/* ── Unit grid ── */
.td-unit-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 16px !important;
}

@media (min-width: 960px) {
  .td-unit-grid { grid-template-columns: repeat(3, 1fr); }
}

.td-unit-stat {
  padding: 12px;
  background: var(--td-bg-subtle);
}

.td-unit-stat-value {
  margin-bottom: 4px;
  line-height: 1.35;
}

/* ── Kontrak ── */
.td-kontrak-icon-wrap {
  display: none;
}

.td-kontrak-card {
  padding: 16px;
}

.td-kontrak-label {
  margin-bottom: 4px;
}

.td-kontrak-period {
  line-height: 1.4;
}

.td-kontrak-badge {
  padding: 3px 8px;
  border-radius: 6px;
  background: var(--td-bg-subtle);
  border: 1px solid var(--td-border);
  font-size: var(--td-label-size);
  font-weight: var(--td-label-weight);
  color: var(--td-label-color);
  align-self: flex-start;
}

.td-kontrak-subcard {
  padding: 12px;
  background: var(--td-bg-subtle);
  margin-bottom: 12px;
}

.td-kontrak-subcard:last-child {
  margin-bottom: 0;
}

.td-kontrak-sub-label {
  margin-bottom: 4px;
}

/* ── Foto ── */
.td-foto-card {
  overflow: hidden;
}

.td-foto-img-wrap {
  cursor: pointer;
}

.td-foto-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-top: 1px solid var(--td-border);
}

/* ── Complaints / Surat ── */
.td-complaint-item {
  padding: var(--td-row-gap) 0;
  border-bottom: 1px solid var(--td-border);
}

.td-complaint-item--last {
  border-bottom: none;
  padding-bottom: 0;
}

.td-complaint-title {
  margin: 0;
}

.td-complaint-content {
  margin: 0;
  color: var(--td-value-color);
}

/* ── Badges ── */
.td-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: var(--td-label-size);
  font-weight: var(--td-label-weight);
  border: 1px solid var(--td-border);
}

.td-badge--neutral {
  background: var(--td-bg-subtle);
  color: var(--td-label-color);
}

.td-badge--danger {
  background: var(--td-danger-bg);
  color: var(--td-danger);
  border-color: var(--td-danger-border);
}

/* ── Documents ── */
.td-doc-card {
  padding: 16px;
  height: 100%;
}

.td-doc-title {
  line-height: 1.4;
  margin-bottom: 8px;
}

.td-doc-preview {
  border-radius: 6px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: var(--td-bg-subtle);
  border: 1px solid var(--td-border);
  box-shadow: none;
}

.td-doc-preview--pdf {
  flex-direction: column;
}

.td-doc-emoji {
  font-size: 24px;
  margin-bottom: 4px;
}

.td-validated {
  font-size: var(--td-label-size);
  font-weight: var(--td-label-weight);
  padding: 3px 8px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--td-border);
}

.td-validated--ok {
  background: var(--td-bg-subtle);
  color: var(--td-label-color);
}

.td-validated--no {
  background: var(--td-danger-bg);
  color: var(--td-danger);
  border-color: var(--td-danger-border);
}

/* ── Finance ── */
.td-summary {
  padding: 16px;
  background: var(--td-bg-subtle);
}

.td-summary-label {
  margin-bottom: 4px;
}

.td-summary-value {
  margin-bottom: 0;
  line-height: 1.35;
}

/* ── VA ── */
.td-va-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  padding: 16px !important;
}

@media (min-width: 960px) {
  .td-va-grid { grid-template-columns: 1fr 1fr; }
}

.td-va-card {
  padding: 16px;
  background: var(--td-bg-subtle);
}

.td-va-label {
  margin-bottom: 4px;
}

.td-va-value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  margin-bottom: 0;
  letter-spacing: 0.01em;
}

/* ── Invoice ── */
.td-invoice-card {
  padding: 16px;
}

.td-invoice-dot {
  width: 6px;
  height: 6px;
  border-radius: 6px;
  flex-shrink: 0;
  margin-top: 7px;
}

.td-invoice-dot--neutral { background: #cbd5e1; }
.td-invoice-dot--danger { background: var(--td-danger); }

.td-date-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: var(--td-label-size);
  font-weight: var(--td-label-weight);
  border: 1px solid var(--td-border);
}

.td-date-badge--neutral {
  background: var(--td-bg-subtle);
  color: var(--td-label-color);
}

.td-date-badge--danger {
  background: var(--td-danger-bg);
  border-color: var(--td-danger-border);
  color: var(--td-danger);
}

/* ── Invoice air ── */
.td-invoice-air-header {
  border-bottom: 1px solid var(--td-border);
  padding-bottom: var(--td-row-gap);
  margin-bottom: var(--td-row-gap);
}

.td-meter-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  border-bottom: 1px solid var(--td-border);
  padding-bottom: var(--td-row-gap);
  margin-bottom: var(--td-row-gap);
}

.td-receipt {
  padding: 16px;
  background: var(--td-bg-subtle);
}

.td-receipt-title {
  text-align: left;
  border-bottom: 1px solid var(--td-border);
  padding-bottom: 12px;
  margin-bottom: 12px;
}

.td-receipt-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 9px 0;
  border-bottom: 1px solid var(--td-border);
}

.td-receipt-row:last-child {
  border-bottom: none;
}

.td-invoice-air-total {
  border-top: 1px solid var(--td-border);
  padding-top: var(--td-row-gap);
}

/* ── Device ── */
.td-device-row {
  padding: 16px;
}

.td-device-icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.td-device-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.td-device-index {
  font-size: var(--td-label-size);
  font-weight: var(--td-label-weight);
  color: var(--td-label-color);
  background: var(--td-bg-subtle);
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid var(--td-border);
  flex-shrink: 0;
}

.td-device-empty {
  padding: 24px 16px;
  border-style: dashed;
  background: var(--td-bg-subtle);
  text-align: center;
  box-shadow: none;
}

/* ── Modal ── */
.td-modal-header {
  border-bottom: 1px solid var(--td-border);
}

.td-doc-fallback {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.td-empty {
  text-align: center;
  padding: 24px 0 !important;
}

/* ── Panel padding overrides ── */
.td-panel .pa-4,
.td-panel .pa-3,
.td-panel .pa-2 {
  padding: 16px !important;
}

.td-panel.mb-5 {
  margin-bottom: var(--td-row-gap) !important;
}

.td-root .rounded-lg {
  border-radius: 6px !important;
}
</style>
